export default "__VITE_ASSET__D3JlJ$F5__"